import { lucideIconRegistry } from "yeati-ui";
import type { LucideIcon } from "lucide-react";

/**
 * Resolve a Lucide icon component from its PascalCase name string.
 * Returns undefined if the icon name is not in the shared registry.
 *
 * Backed by yeati-ui's `lucideIconRegistry` so all dynamic icon lookups
 * (admin pickers, API-configured icons, dashboard widget icons) share
 * the same tree-shakable set. Adding a new icon to a picker requires
 * also adding it to `yeati-ui/src/utils/lucideIconRegistry.ts`.
 */
export const getLucideIcon = (name: string): LucideIcon | undefined => {
  return lucideIconRegistry[name];
};
